import Dropzone from 'dropzone'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import IconButton from '../../../common/common/icon_button/icon_button'
import IntlMessage from '../../../common/common/intl/intl_message'
import Util from '../../../lib/util'

class DocumentUpload extends Component {
  constructor (props) {
    super(props)

    this.state = {
      progressValue: 0,
      upload: !!(props.fileObj && props.fileObj.fileName)
    }

    this._references = {
      refUpload: React.createRef()
    }

    this.dropZone = null
  }

  static get propTypes () {
    return {
      allowedAttachments: PropTypes.arrayOf(PropTypes.string),
      className: PropTypes.string,
      onDeleteClick: PropTypes.func,
      uploadError: PropTypes.func,
      uploadSuccess: PropTypes.func,
      error: PropTypes.string,
      fileObj: PropTypes.object
    }
  }

  static get defaultProps () {
    return {
      allowedAttachments: ['pdf'],
      className: 'content',
      onDeleteClick: null,
      uploadError: null,
      uploadSuccess: null,
      error: false,
      fileObj: null
    }
  }

  componentDidMount () {
    this.initUpload()
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.fileObj !== this.props.fileObj) {
      this.setState({ upload: !!nextProps.fileObj })
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevState.upload !== this.state.upload) {
      this.initUpload()
    }
  }

  initUpload () {
    if (this._references.refUpload.current) {
      this.dropZone = new Dropzone(
        ReactDOM.findDOMNode(this._references.refUpload.current),
        {
          paramName: 'uri',
          maxFilesize: 10,
          url: '/api/uploads',
          uploadMultiple: false,
          previewTemplate: '<div class="dz-preview"></div>',
          hiddenInputContainer: '.content',
          clickable: ['.expense-upload > .content'],
          acceptedFiles: this.props.allowedAttachments.map(val => `.${val}`).join(',')
        }
      )

      this.dropZone.on('error', this._onError.bind(this))
      this.dropZone.on('uploadprogress', this._onProgress.bind(this))
      this.dropZone.on('success', this._onSuccess.bind(this))
    }
  }

  componentWillUnmount () {
    if (this.dropZone) {
      this.dropZone.disable()
      this.dropZone = null
    }
  }

  render () {
    const className = `expense-upload${this.props.error ? ' error' : ''}`

    if (!this.state.upload) {
      return (
        <div className={className} ref={this._references.refUpload}>
          <div className='content'>
            <i className='icon icon-form-attachment' />
            <div className='title'>
              <h2>
                <IntlMessage ident='expense.form.attachmentTitle' />
              </h2>
            </div>
            <span className='info'>
              <IntlMessage ident='expense.form.attachmentInfo' />
              <br />
              <IntlMessage ident='expense.form.allowedUploadExtensions' />
              <span>:&nbsp;</span>
              <span className='allowed-attachments'>
                {this._renderAllowedUploadExtensions(this.props.allowedAttachments)}
              </span>
            </span>
          </div>
        </div>
      )
    }

    return this._renderUploadedContent()
  }

  isValidate () {
    return !!this.state.upload
  }

  _renderAllowedUploadExtensions (extensions) {
    const ar = [...extensions]
    const lastItem = ar.pop().toUpperCase()

    if (extensions.length > 1) {
      const beforeAnd = ar.join(', ').toUpperCase()
      return <>{beforeAnd} <IntlMessage ident='expense.form.and' /> {lastItem}</>
    }

    return lastItem
  }

  _renderUploadedContent () {
    if (this.props.fileObj) {
      const fileSrc = this.props.fileObj.url
      return (
        <a
          className='uploaded'
          href={fileSrc}
          target='_blank'
          rel='noopener noreferrer'
        >
          <div className='content'>
            <i className='icon icon-common-success-tick' />
            <div className='title'>{this._renderFile()}</div>
            <span className='sub-info'>
              <IntlMessage ident='expense.form.fileUploadedInfo' />
            </span>
          </div>
          <IconButton
            type='primary'
            icon='header-upload-delete'
            canHover
            title='expense.form.deleteAttachment'
            className='act-avatar-delete'
            onClick={this._onDeleteClick.bind(this)}
          />
        </a>
      )
    }

    return this.renderErrorMsg()
  }

  _renderFile () {
    if (this.props.fileObj && this.props.fileObj !== '') {
      return <h2 className='title'>{this.props.fileObj.name}</h2>
    }

    return null
  }

  renderErrorMsg () {
    if (this.props.error !== undefined && this.props.error) {
      return <p className='upload-error'>{this.props.error}</p>
    }

    return null
  }

  _onSuccess (file, message, e) {
    const ext = Util.getExtension(message.id)

    if (this.props.allowedAttachments.includes(ext)) {
      this.setState({
        progressValue: 0,
        upload: true
      })
    } else {
      this.setState({ upload: false })
    }

    if (this.props.uploadSuccess) {
      this.props.uploadSuccess(file, message, e)
    }
  }

  _onError (file, message, _e) {
    this.setState({ upload: false })

    if (this.props.uploadError) {
      this.props.uploadError(file, message)
    }
  }

  _onProgress (file, progress, _e) {
    this.setState({ progressValue: progress })
  }

  _onDeleteClick (e) {
    e.preventDefault()
    e.stopPropagation()

    if (this.props.fileObj) {
      this.props.fileObj.name = ''
      this.props.fileObj.fileName = ''
      this.props.fileObj.url = ''
    }

    if (this.props.onDeleteClick) {
      this.props.onDeleteClick(e)
    }
    this.setState({ upload: false })
  }
}

export default DocumentUpload
